import React from 'react';
import './style.css';

class Loading extends React.Component {

    render() {
        return (
            <div style={{width:"100%", height:"100%", position:"absolute", backgroundColor: "rgba(0, 0, 0, 0.2)", zIndex:this.props.zIndex}}>
                <div style={{top:"50%", left:"50%", transform:"translate(-20px, -20px)", position:"absolute"}}>
                    <div style={{position:"relative"}}>
                        <svg className="circle-loader" width="40" height="40">
                            <circle cx="20" cy="20" r="15"/>
                        </svg>
                        <svg className="circle-loader2" width="40" height="40">
                            <circle cx="20" cy="20" r="15"/>
                        </svg>
                    </div>
                    <div style={{position:"relative", top:50, left:-40}}>
                        {this.props.text}
                    </div>
                </div>
            </div>
        );
    }
}


export default Loading;
